import React from 'react';

import { CustomSectionItem } from '@app/gen/side_menu';

import { SidebarMenu } from '../SidebarMenu';

interface SidebarCustomSectionItemProps {
  item: CustomSectionItem;
  sidebarOpened: boolean;
  isSkeletonLoading: boolean;
  onMenuItemClick: (pageTitle: string) => void;
}

export const SidebarCustomSectionItem = ({
  item,
  sidebarOpened,
  isSkeletonLoading,
  onMenuItemClick,
}: SidebarCustomSectionItemProps) => {
  const { name, children } = item;

  return (
    <SidebarMenu
      menuLabel={name}
      sidebarOpened={sidebarOpened}
      skeletonLoading={isSkeletonLoading}
      key={item.name}
      onMenuItemClick={onMenuItemClick}
      items={children}
    />
  );
};
